var StatementItemTypes;
(function (StatementItemTypes) {
    StatementItemTypes["SPEND"] = "SPEND_CREDIT";
    StatementItemTypes["PERKS_GO_CASHBACK"] = "cashback";
    StatementItemTypes["MANUAL_CREDIT"] = "MANUAL_CREDIT";
    StatementItemTypes["SEND_CREDIT_AS_REWARD"] = "send-credit-as-reward";
    StatementItemTypes["USE_CREDIT_TO_BUY_REWARD"] = "use-credit-to-buy-reward";
    StatementItemTypes["TRANSFER_TO_REWARDS_WALLET"] = "transfer-to-rewards-wallet";
    StatementItemTypes["TOP_UP_BANK_TRANSFER"] = "tenant-wallet-topup-bank-transfer";
    StatementItemTypes["TOP_UP_CARD_PAYMENT"] = "tenant-wallet-topup-card-payment";
    StatementItemTypes["NEW_TOP_UP_BANK_TRANSFER"] = "wallet-topup-bank-transfer";
    StatementItemTypes["NEW_TOP_UP_CARD_PAYMENT"] = "wallet-topup-card-payment";
    StatementItemTypes["REFUND_FROM_REWARDS_WALLET"] = "refund-from-rewards-wallet";
    StatementItemTypes["SEND_CREDIT"] = "SEND_CREDIT";
    StatementItemTypes["MANUAL_REFUND"] = "MANUAL_REFUND";
})(StatementItemTypes || (StatementItemTypes = {}));
export default StatementItemTypes;
